export default {
  type: 'menu',
  code: '11990000',
  addNode: {
    type: 'btns',
    code: '11990100'
  },
  deleteNode: {
    type: 'btns',
    code: '11990200'
  }
}
